import trialMinerBackgroundImage from 'assets/backgrounds/trial-miner/trial-miner-background.png';
import trialMinerBackgroundLaptopImage from 'assets/backgrounds/trial-miner/trial-miner-background-laptop.png';
import trialMinerBackgroundMobileImage from 'assets/backgrounds/trial-miner/trial-miner-background-mobile.png';
import styled from 'styled-components';
import { BreakPoint } from 'styles/style-variables/breakpoint';
import { EColors } from 'styles/style-variables/colors';

import { SText } from 'components/styled/SText';
import { Button } from 'components/ui/Button';

export const TrialMinerSection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 24px;
  background-image: url(${trialMinerBackgroundImage});
  background-repeat: no-repeat;
  background-size: 100% 100%;

  & svg {
    height: 125.014px;
  }

  @media (max-width: ${BreakPoint.LaptopLow}) {
    background-image: url(${trialMinerBackgroundLaptopImage});

    & svg {
      height: 169.593px;
    }
  }

  @media (max-width: ${BreakPoint.MobileCustom}) {
    padding: 16px;
    border-radius: 16px;
    background-image: url(${trialMinerBackgroundMobileImage});

    & svg {
      height: 152.149px;
    }
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-right: 120px;

  @media (max-width: ${BreakPoint.MobileTop}) {
    gap: 16px;
    padding-right: 0;
  }
`;

export const TrialMinerSectionCard = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @media (max-width: ${BreakPoint.MobileTop}) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const TrialMinerTittleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  @media (max-width: ${BreakPoint.LaptopTop}) {
    flex-direction: column;
    align-items: start;
    gap: 8px;
  }
`;

export const TrialMinerTittle = styled(SText)`
  font-size: 32px;
  line-height: 40px;
  color: ${EColors.White};

  @media (max-width: ${BreakPoint.TabletTop}) {
    font-variant-numeric: lining-nums tabular-nums;
    font-size: 28px;
    line-height: 34px;
  }

  @media (max-width: ${BreakPoint.MobileTop}) {
    font-variant-numeric: lining-nums tabular-nums;
    font-size: 20px;
    line-height: 28px;
  }
`;

export const BadgesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: ${BreakPoint.MobileTop}) {
    gap: 4px;
  }
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 8px;
  background-color: ${EColors.TrialBadgeBack};

  & svg {
    width: 16px;
    height: 16px;
  }

  @media (max-width: ${BreakPoint.MobileTop}) {
    padding: 4px 8px;

    & svg {
      display: none;
    }
  }
`;

export const TextBadge = styled(SText)`
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: ${EColors.White};
  font-variant-numeric: lining-nums tabular-nums;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: ${BreakPoint.MobileTop}) {
    flex-direction: column;
    width: 100%;
  }
`;

export const StartTrialButton = styled(Button)`
  padding: 12px 24px;
  border-radius: 24px;
  background-color: ${EColors.Blue3};

  &:active {
    background-color: ${EColors.Blue3};
  }

  &:disabled {
    background-color: ${EColors.Gray3};
  }

  @media (max-width: ${BreakPoint.MobileTop}) {
    width: 100%;
  }
`;

export const StartTrialText = styled(SText)`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: ${EColors.White};
`;

export const StartTrialTextBold = styled(StartTrialText)`
  font-weight: 700;
`;

export const HowItWorksButton = styled(Button)`
  padding: 12px 24px;
  border-radius: 24px;
  background: rgb(216 238 255 / 10%);

  & svg {
    width: 16px;
    height: 16px;
  }

  &:focus {
    background: rgb(216 238 255 / 20%);
  }

  &:hover {
    background: rgb(216 238 255 / 20%);
  }

  &:active {
    background: rgb(216 238 255 / 30%);
  }

  @media (max-width: ${BreakPoint.MobileTop}) {
    width: 100%;
    padding: 0;
    background: transparent;
    color: ${EColors.White};
  }
`;

export const MinerIconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    position: absolute;
    top: 0;
    right: 0;
    height: 125.014px;
    aspect-ratio: 129/125.01;
  }

  @media (max-width: ${BreakPoint.LaptopTop}) {

    & img {
      top: 0;
      height: 169.593px;
      aspect-ratio: 175/169.59;
    }
  }

  @media (max-width: ${BreakPoint.MobileTop}) {
    height: max-content;
    margin-top: 24px;

    & img {
      position: initial;
      height: 152.149px;
      aspect-ratio: 157/152.15;
    }
  }
`;
